import { Injectable, Injector } from '@angular/core';
import { UserService } from './user.service';
import { Observable, Subscription, } from 'rxjs';
import { ConfigurationService } from './configuration.service';
import { Router } from '@angular/router';
import { LoadingService } from '../../common/layout/loading.service';
import { concatMap } from 'rxjs/operators';

@Injectable()
export class AppInitializerService {

    private subscriptions: Subscription = new Subscription();

    public _isInitialized = false;

    constructor(
        private injector: Injector,
        private userService: UserService,
        private configurationService: ConfigurationService,
        public loadingService: LoadingService
    ) {
    }

    get isInitialized(): boolean {
        return this._isInitialized;
    }


    public init(): Promise<any> {
        return new Promise((resolve) => {
            const chain = this.chain();
            chain
                .subscribe((values) => {
                        this.subscriptions.unsubscribe();
                        this._isInitialized = true;
                        this.userService.userHasLogged();
                        resolve();
                    },
                    (error) => {
                        this.subscriptions.unsubscribe();
                        resolve();
                    });
        });
    }

    chain() {
        const configuration$: Observable<any> = this.configurationService.downloadConfiguration();
        const currentUser$: Observable<any> = this.userService.downloadCurrentUser();
        return currentUser$;
    }

    public get router(): Router {
        return this.injector.get(Router);
    }
}
